const injectSecondaryImages = () => {
	if (!window.matchMedia('(hover: hover)').matches) return;

	const templates = document.querySelectorAll(
		'.card-wrapper.product-card-wrapper .secondary-image-template:not([data-injected="true"])'
	);

	// console.log('[injectSecondaryImages] found templates:', templates.length);

	templates.forEach((template) => {
		const container = template.closest('.media');
		if (!container || container.querySelector('.secondary-image')) return;

		const primaryImage = container.querySelector('img:not(.secondary-image)');
		if (!primaryImage) return;

		const inject = () => {
			if (template.getAttribute('data-injected') === 'true') return;

			const img = document.createElement('img');
			img.className = 'motion-reduce secondary-image';
			img.src = template.dataset.imageUrl;
			img.srcset = template.dataset.srcset;
			img.sizes = template.dataset.sizes;
			img.width = template.dataset.width;
			img.height = template.dataset.height;
			img.alt = '';
			// console.log('[injectSecondaryImages] injecting image at', performance.now(), 'for', img.src);
			container.appendChild(img);
			template.setAttribute('data-injected', 'true');
			img.addEventListener(
				'load',
				() => {
					img.classList.add('loaded');
				},
				{ once: true }
			);
		};

		if (primaryImage.complete) {
			inject();
		} else {
			primaryImage.addEventListener('load', inject, { once: true });
		}
	});
};

window.injectSecondaryImages = injectSecondaryImages;

// Attempt to inject as soon as product grid is available
document.addEventListener('DOMContentLoaded', () => {
	const selector = '.product-grid';
	waitForElement(selector, false)
		.then(async () => {
			window.injectSecondaryImages();
			// console.log('Target element found. Injected secondary images after initial mutation');
		})
		.catch((err) => {
			console.error(err);
		});
});

// Final fallback in case some sections are loaded later
window.addEventListener('load', () => {
	window.injectSecondaryImages?.();
});
